export const aiCore = {
  process: async (input: { type: string; content: string }): Promise<any> => {
    return { response: 'AI system is currently being upgraded. Please contact our team directly.' };
  },
};
